import moment from "moment";

const getDateRangeFromQuickOption = (value) => {
    const now = moment();
    let start, end;

    switch (value) {
      case 'day':
        start = end = now;
        break;
      case 'week':
        start = moment().startOf('week');
        end = moment().endOf('week');
        break;
      case 'month':
        start = moment().startOf('month');
        end = moment().endOf('month');
        break;
      case '3months':
        start = moment().subtract(3, 'months');
        end = now;
        break;
      case '4months':
        start = moment().subtract(4, 'months').startOf('month');
        end = now.endOf('month');
        break;
      case '6months':
        start = moment().subtract(6, 'months');
        end = now;
        break;
      case '12months':
        start = moment().subtract(12, 'months');
        end = now;
        break;
      case '1month':
        start = moment().subtract(1, 'months');
        end = now;
        break;
      case 'quarter': // Quarter to Date
        start = moment().startOf('quarter');
        end = moment().endOf('day');
        break;
      case 'all': // All Time
        start = moment(new Date(0));
        end = moment(new Date());
        break;
      default:
        return null;
    }

    return { start: start.toDate(), end: end.toDate() };
  };

/** Default date window for Revenue / Count dashboards (rolling ~1 month; Quick Range shows empty until user picks a preset). */
const getDefaultDashboardDateRange = () => [
  moment().startOf('month').toDate(),
  moment().toDate(),
];

/** Shared quick-range options for partner dashboards (Revenue, Count). */
const dashboardQuickRanges = [
  { label: 'Current Day', value: 'day' },
  { label: 'Current Week', value: 'week' },
  { label: 'Current Month', value: 'month' },
  { label: 'Last 1 Month', value: '1month' },
  { label: 'Last 3 Months', value: '3months' },
  { label: 'Last 6 Months', value: '6months' },
  { label: 'Last 12 Months', value: '12months' },
  { label: 'Quarter to date', value: 'quarter' },
  { label: 'All Time', value: 'all' },
];

/** POST body for `adminOrchestrator/app/list` (Reports / dashboards). */
const appListPayloadDefaults = {
  page: 1,
  limit: 500,
  sortBy: 'createdAt',
  sortDirection: 'DESC',
  search: '',
  filter: { isActive: true },
};

/**
 * Maps `adminOrchestrator/app/list` items to `{ id, companyName, emailAddress }` for partner Selects.
 * Prefers `businessPartnerId` when present (for downstream businessPartnerId APIs).
 */
const mapAppListItemsForCustomerSelect = (items) => {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => {
      const rawId =
        item?.businessPartnerId != null && item.businessPartnerId !== ''
          ? item.businessPartnerId
          : item?.id;
      if (rawId == null || rawId === '') return null;
      return {
        id: String(rawId),
        companyName:
          item.appDisplayName ||
          item.companyName ||
          item.appName ||
          String(rawId),
        emailAddress: item.emailAddress || item.businessPartnerEmail || '',
      };
    })
    .filter(Boolean);
};

export {
  getDateRangeFromQuickOption,
  getDefaultDashboardDateRange,
  dashboardQuickRanges,
  appListPayloadDefaults,
  mapAppListItemsForCustomerSelect,
};